import { useEffect } from "react";

import { useAppSelector } from "~/app/store";
import { listenForFulfillmentCenter } from "~/lib/signalr";
import { selectSignalRReadyMain } from "~/redux/selectors/appSelectors";
import { selectUsersFulfillmentCenterId } from "~/redux/selectors/storeSelectors";

export function useAndonBoardSignalRListen(layoutFcIds: string[]): void {
  const signalRReadyMain = useAppSelector(selectSignalRReadyMain);
  const siteFulfillmentCenterId = useAppSelector(
    selectUsersFulfillmentCenterId
  );

  const layoutFcIdsKey = layoutFcIds.slice().sort().join(",");

  useEffect(() => {
    if (!signalRReadyMain) return;

    const fcIds = layoutFcIdsKey ? layoutFcIdsKey.split(",") : [];
    for (const fulfillmentCenterId of fcIds) {
      if (
        fulfillmentCenterId &&
        fulfillmentCenterId !== siteFulfillmentCenterId
      ) {
        void listenForFulfillmentCenter(fulfillmentCenterId);
      }
    }
  }, [signalRReadyMain, siteFulfillmentCenterId, layoutFcIdsKey]);
}
